import axios from 'axios';
import config from '../../../config';

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('googleIdToken')}`,
});

// Returns the new in-app path for an old URL, or null if none is configured.
const lookupReportRedirect = async (path) => {
  try {
    const res = await axios.get(`${config.apiURL}/getReportRedirect`, {
      headers: authHeaders(),
      params: { path },
    });
    return res.data?.newUrl || null;
  } catch (err) {
    return null;
  }
};

const getReportRedirects = async () => {
  try {
    const res = await axios.get(`${config.apiURL}/getReportRedirects`, {
      headers: authHeaders(),
    });
    return Array.isArray(res.data) ? res.data : [];
  } catch (err) {
    return [];
  }
};

const addReportRedirect = async (oldUrl, newUrl, createdBy) => {
  try {
    return await axios.post(
      `${config.apiURL}/addReportRedirect`,
      { oldUrl, newUrl, createdBy },
      { headers: authHeaders() },
    );
  } catch (err) {
    return err;
  }
};

const deleteReportRedirect = async (id) => {
  try {
    return await axios.delete(`${config.apiURL}/deleteReportRedirect`, {
      headers: authHeaders(),
      data: { id },
    });
  } catch (err) {
    return err;
  }
};

export {
  addReportRedirect,
  deleteReportRedirect,
  getReportRedirects,
  lookupReportRedirect,
};
